import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Device } from '../../interfaces/api/device';
import { fetchDevices } from '../services/devices.service';

interface DeviceState {
	devices: {
		[id: number]: Device;
	};
	isLoading: boolean;
}

const initialState = {
	devices: [],
	isLoading: false,
} as DeviceState;

export const fetchDevicesThunk = createAsyncThunk<Device[], void>(
	'device/fetchDevices',
	async (_undefined, { rejectWithValue }) => {
		try {
			return await fetchDevices();
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

const deviceSlice = createSlice({
	name: 'device',
	initialState,
	reducers: {
		resetDevice: (state) => {
			Object.assign(state, initialState);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchDevicesThunk.fulfilled, (state, action) => {
			const ret: { [id: number]: Device } = {};
			state.devices = action.payload.reduce((obj, device) => {
				obj[device.id] = device;
				return obj;
			}, ret);
			state.isLoading = false;
		});
		builder.addCase(fetchDevicesThunk.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchDevicesThunk.rejected, (state, action) => {
			state.devices = [];
			state.isLoading = false;
		});
	},
});

export const { resetDevice } = deviceSlice.actions;

export default deviceSlice;
